const o = {
  defaultProps: {
    arrow: !0
  }
};
export {
  o as default
};
